export enum GlobalEContractingRoutes {
  BASE = 'myaccount-contract'
}
